import * as React from 'react';

import { ReportOptions } from '@showbie-socrative/socrative-utils';

import { Stack } from '~shared/components/Stack';
import { ReportTypeContext } from '~teacher/components/ExportReports/ReportTypeContext';
import { proCheck } from '~teacher/util/proCheck';

import { ReportOptionBooleanControl } from './ReportOptionBooleanControl';
import {
  ExportReportDispatch,
  ReportOptionState,
} from './ReportOptionHookReducer';
import { ProOnlyReportOptions } from './ReportOptionTypes';

interface Props {
  shouldShowProBadge: boolean;
  optionState: ReportOptionState;
  options: Array<{
    label: string;
    identifier: ReportOptions;
  }>;
  dispatch: ExportReportDispatch;
}

const ReportOptionControlList: React.FC<Props> = ({
  options,
  dispatch,
  optionState,
  shouldShowProBadge,
}: React.PropsWithChildren<Props>) => {
  const canCustomizeExportResults = proCheck.canCustomizeExportResults();
  return (
    <ReportTypeContext.Consumer>
      {(reportType) => (
        <Stack dividers>
          {options.map(({ identifier, label }) => {
            const { [identifier]: value = false } = optionState;
            const shouldProGuardReportOptionRow =
              !canCustomizeExportResults &&
              ProOnlyReportOptions.includes(identifier);
            // Right now this control only supports ReportOptionBooleanControl but in the future we could support other configuration options (Like a select list?)
            return (
              <ReportOptionBooleanControl
                shouldProGuardReportOptionRow={shouldProGuardReportOptionRow}
                shouldShowProBadge={shouldShowProBadge}
                key={identifier}
                identifier={identifier}
                label={label}
                value={value}
                dispatch={dispatch}
                reportType={reportType}
              />
            );
          })}
        </Stack>
      )}
    </ReportTypeContext.Consumer>
  );
};

export { ReportOptionControlList };
